export default {
    name: 'app-video',
    props: ['videoId'],
    data() {
        return {
            active: false,
            paused: true,
            player: null,
            playerParams : {
                autoplay: true,
                controls: false,
                mute: false
            },
            playPercent: 0,
            opened: false,
            loading: false
        }
    },
    mounted() {
        this.selectVideo();
    },
    methods: {
        selectVideo() {
            this.$nextTick(() => {

                setTimeout(() => {
                    this.opened = true;
                }, 2000)

                /* eslint-disable */
                this.player = DM.player(this.$refs['player'].$el.children[0], {
                    video: this.videoId,
                    width: '100%',
                    height: '100%',
                    params: this.playerParams
                });

                this.active = true;

                this.player.addEventListener('start', function (e) {
                    this.paused = false;                   
                }.bind(this));

                this.player.addEventListener('play', function (e) {
                    this.paused = false;
                }.bind(this));

                this.player.addEventListener('pause', function (e) {
                    this.paused = true;
                }.bind(this));
            
                this.player.addEventListener('end', function (e) {
                    this.$router.push('/')         
                }.bind(this));

                this.player.addEventListener('seeking', function (e) {
                    this.paused = true;
                    this.loading = true;
                }.bind(this));

                this.player.addEventListener('seeked', function (e) {
                    this.paused = false;
                    this.loading = false;
                }.bind(this));


                /* eslint-enable */ 
                const player = this.player;
                const t = setInterval(() => {
                    this.playPercent = (player.currentTime / player.duration * 100);
                    if (this.playPercent >= 100) {
                        clearInterval(t);
                    }
                }, 100);
            })
        },
        play() {
            this.paused = false;
            this.player.play()
        },
        pause() {
            this.paused = true;
            this.player.pause();
        },
        close() {
            this.player.pause()
            this.active = false;
            this.opened = false;
        },
        seekVideo(evt) {
            const duration = this.player.duration
            const mPX = evt.offsetX;
            const fw = this.$refs['progress-bar'].clientWidth;
            const percent = (mPX / fw)
            const seconds = duration * percent
            this.player.seek(seconds)
        }
    }
}
